module.exports = __webpack_public_path__ + "static/media/content-01-m.94bb4858.png";